import React from 'react'
import { Divider, Fab, Grid, Hidden, Typography, Zoom, useMediaQuery, useScrollTrigger } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import {
    HiOutlineArrowNarrowUp,
} from "react-icons/hi";


const AboutUs = () => {
    const LayoutWeb = useMediaQuery('(min-width:1180px)');
    const LayoutIpad = useMediaQuery('(min-width:820px)');
    const LayoutPhone = useMediaQuery('(min-width:930px)');

    return (
        <React.Fragment>

            {LayoutWeb ? (
                <div className='session-f-container'>
                    <Grid item >
                        <div className='container-text-contact'>
                            <Typography className='text-unit'>
                                <span>กองทุนจัดการ</span><br />
                                ซากดึกดำบรรพ์<br />
                                กรมทรัพยากรธรณี
                            </Typography>
                            <br />
                            <br />
                            <Typography className='text-address'>
                                <span>อาคารโกเมน ชั้นที่ 1 </span>
                                <br />
                                เลขที่ 75/10 ถนนพระรามที่ 6 แขวงทุ่งพญาไท เขตราชเทวี กทม. 10400
                            </Typography>
                        </div>
                        <Grid item md={4} xs={12}>
                            <div className='container-box-contact'>
                                <div className='box-contact-tel'>
                                    <Grid container alignItems='center' >
                                        <Grid item  >
                                            <WhatsAppIcon style={{ color: 'white', fontSize: '4em',marginRight:'2rem' }} />
                                        </Grid>
                                        <Grid item >
                                            <Typography>โทรศัพท์</Typography>

                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography>081-8906448, 02-6219645</Typography>
                                        </Grid>
                                    </Grid>
                                </div>
                                <div className='box-contact-email'>
                                    <Grid container alignItems='center' >
                                        <Grid item >
                                            <MailOutlineOutlinedIcon style={{ color: '#eed8c3', fontSize: '4em',marginRight:'2rem' }} />
                                        </Grid>
                                        <Grid item >
                                            <Typography>อีเมล</Typography>

                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography>finance.dino.dmr@gmail.com</Typography>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </Grid>
                        <ScrollToTop>
                            <Fab
                                color="error"
                                size="large"
                                sx={{
                                    flexDirection: "column",
                                    borderRadius: "16px",
                                    width: "35px",
                                    height: "70px",
                                    textAlign: "center",
                                    lineHeight: "1",
                                    fontSize: "13px",
                                    backgroundColor: "#ff0000"
                                }}
                            >
                                <HiOutlineArrowNarrowUp size="25" />
                                <span style={{ marginTop: '8px', textTransform: 'uppercase', color: 'white' }}>
                                    UP
                                </span>
                            </Fab>
                        </ScrollToTop>
                    </Grid>
                </div>
            ) : (
                <div className='session-f-container-phone'>
                    {/* phone size */}
                    <Grid item >
                        <div className={LayoutIpad && !LayoutPhone ? 'container-text-contact-ipad' : 'container-text-contact-phone'}>
                            <Typography className='text-unit-phone'>
                                <span>กองทุนจัดการซากดึกดำบรรพ์กรมทรัพยากรธรณี </span>
                            </Typography>
                            <br />
                            <br />
                            <Typography className='text-address-phone'>
                                <span>อาคารโกเมน ชั้นที่ 1 เลขที่ 75/10 ถนนพระรามที่ 6 แขวงทุ่งพญาไท เขตราชเทวี กทม. 10400</span>
                            </Typography>
                        </div>
                        <Grid item md={4} xs={12}>
                            <div className='container-box-contact'>
                                <div className='box-contact-tel-phone'>
                                    <Grid container spacing={1} alignItems='center' >
                                        <Grid item md={3} >
                                            <WhatsAppIcon style={{ color: 'white', fontSize: '2em' }} />
                                        </Grid>
                                        <Grid item xs={"auto"}>
                                            <Divider orientation='vertical' />
                                        </Grid>
                                        <Grid item xs={"auto"}>
                                            <Typography>โทรศัพท์</Typography>
                                            <Typography>081-8906448, 02-6219645</Typography>
                                        </Grid>
                                    </Grid>
                                </div>

                                <div className='box-contact-email-phone'>
                                    <Grid container spacing={1} alignItems='center' >
                                        <Grid item md={3}>
                                            <span>  <MailOutlineOutlinedIcon style={{ color: '#eed8c3', fontSize: '2em' }} /></span>
                                        </Grid>
                                        <Grid item xs={"auto"}>
                                            <Divider orientation='vertical' />
                                        </Grid>
                                        <Grid item xs={"auto"}>
                                            <Typography>อีเมล</Typography>
                                            <Typography>finance.dino.dmr@gmail.com</Typography>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </Grid>
                        <ScrollToTop>
                            <Fab
                                color="error"
                                size="large"
                                sx={{
                                    flexDirection: "column",
                                    borderRadius: "16px",
                                    width: "35px",
                                    height: "70px",
                                    textAlign: "center",
                                    lineHeight: "1",
                                    fontSize: "13px",
                                    backgroundColor: "#ff0000"
                                }}
                            >
                                <HiOutlineArrowNarrowUp size="25" />
                                <span style={{ marginTop: '8px', textTransform: 'uppercase', color: 'white' }}>
                                    UP
                                </span>
                            </Fab>
                        </ScrollToTop>
                    </Grid>
                </div>
            )}
        </React.Fragment>
    )
}

export default AboutUs


const ScrollToTop = (props) => {
    const { children } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 300,
    });

    const handleClick = (event) => {
        window.scrollTo({ top: 0, behavior: `smooth` })
    };

    return (
            <Zoom in={trigger}>
                <div
                    onClick={handleClick}
                    role="presentation"
                    style={{
                        position: "fixed",
                        bottom: "12px",
                        right: "15px",
                        width: "46.7px",
                        height: "87.5px",
                        zIndex: 12
                    }}
                >
                    {children}
                </div>
            </Zoom>
    );
};
